import RelatedMaterialVM from './related-material-vm';
export default {
  init: function(){
    console.log('Initializing Kadenze.RelatedMaterialPanel');

    ko.applyBindings(new RelatedMaterialVM(), document.getElementById('related-material'));
  }
};
